import global from './Globals';

export default {
  alertSuccessBorder: global.success,
  alertSuccessBg: global.successFade,
  alertErrorBorder: global.error,
  alertErrorBg: global.errorFade,
  alertWarningBorder: global.warning,
  alertWarningBg: global.warningFade,
  alertPrimaryBorder: global.primary,
  alertPrimaryBg: global.primaryFade,
};
